import { createAction } from 'redux-act'

export const openLoading = createAction()
export const closeLoading = createAction()